import Vue from "vue";
import "./plugins/vuetify";
import { i18n } from "./plugins/i18n";
import App from "./App.vue";
import { router } from "./router/router.js";
import { store } from "./store/store.js";

import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

import vuetify from './plugins/vuetify'


Vue.config.productionTip = false;

console.log("Starting app...")
let app;

var firebaseConfig = {
    apiKey: "AIzaSyAeLtT8iDigCzeitlXh6LGIHV6P-HgKOAQ",
    authDomain: "greipl24.firebaseapp.com",
    databaseURL: "https://greipl24.firebaseio.com",
    projectId: "greipl24",
    storageBucket: "greipl24.appspot.com",
    messagingSenderId: "643353933529",
    appId: "1:643353933529:web:a781b95648318592fbf0c8"
};
console.log(firebase)
firebase.initializeApp(firebaseConfig);
firebase.firestore().settings( { timestampsInSnapshots: true, merge:true } );


import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
const appCheck = initializeAppCheck(firebase.app(), {
    provider: new ReCaptchaV3Provider('6LdefIQcAAAAAL1lNGC7Mef_QLyDKmOniJCYkQdc'),
    isTokenAutoRefreshEnabled: true
  });


// TODO: remove, just for test der cookies
//localStorage.clear();

firebase.auth().onAuthStateChanged(() => {


    // Makes sure that the connection to firebase is
    // set up before creatting the app.
    if (!app) {

        console.log("MAIN.JS: First run ....... Creating app started ...");
        console.log("MAIN.JS: Mode is " + process.env.NODE_ENV);

 
       
        app = new Vue({
            el: "#app",
            i18n,
            router,
            store,
            vuetify,
            render: h => h(App)
        });

    }

    console.log("XX", app.$store);

    if (firebase != null && firebase.auth() != null) {
        let u = firebase.auth().currentUser;
        console.log("MAIN.JS:     Auth State Changed ");
        console.log("             Current user =  ", u);
        console.log("                     Mail =  ", u ? u.email : " - ");
        console.log("                Anonymous =  ", u ? u.isAnonymous : " - ");
        console.log("                      UID =  ", u ? u.uid : " - ");
        app.$store.commit("setUser", u);
    }
    else {

        console.log("          No user is signed in.");

        // Nur zur sicherheit, wenn doch ein ano unerwegs ist.
        if (firebase.auth().currentUser.isAnonymous == null) {
            firebase.auth().signOut();
        }
        app.$store.commit("setUser", null);
    }
});
